import { InjectionToken } from '@angular/core';

export const BUILD_TIME = new InjectionToken<number>('BUILD_TIME', {
	factory: () => Date.now(),
});
